import { useAppEmailVerificationRestricted } from './EmailVerificationRestrictionContext';

export function useAppEmailVerificationBanner() {
  return useAppEmailVerificationRestricted();
}
